import styled from "styled-components"

export const StyledDiv = styled.div`
  background-color: ${({theme}) => theme.colors.greys.mediumLight};

  &.homepage-pop-tart-enter {
    height: 0;
    overflow: hidden;
  }
  &.homepage-pop-tart-enter-active {
    height: 53px;
    overflow: hidden;
    transition: height 300ms;
  }

  &.homepage-pop-tart-exit {
    height: 53px;
    overflow: hidden;
  }
  &.homepage-pop-tart-exit-active {
    height: 0;
    overflow: hidden;
    transition: height 300ms;
  }
`
